import { InputProps } from '@/types/form/input-props';
import { useId } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../select';

export type SelectOption = {
  label: string;
  value: string;
};

export function SelectInput({
  label,
  value,
  onChange,
  name,
  placeholder,
  options,
}: InputProps<string> & { options: SelectOption[] }) {
  const id = useId();

  return (
    <div className="group relative">
      <label
        htmlFor={id}
        className="bg-background text-foreground absolute start-1 top-0 z-10 block -translate-y-1/2 px-2 text-xs font-medium group-has-disabled:opacity-50"
      >
        {label}
      </label>
      <Select defaultValue={value} onValueChange={onChange} value={value} name={name}>
        <SelectTrigger id={id}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
